import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";

import {
  Modal,
  Button,
  Divider
} from '@lockerpm/design';

import {
  GroupOutlined,
  UserOutlined
} from "@ant-design/icons";

import enterpriseServices from "../../services/enterprise";
import global from "../../config/global";
import common from "../../utils/common";

const EnterpriseInvitationsModal = () => {
  const { t } = useTranslation();

  const enterpriseInvitations = useSelector((state) => state.enterprise.enterpriseInvitations);

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState('')

  useEffect(() => {
    if (enterpriseInvitations?.length > 0) {
      setVisible(true)
    }
  }, [enterpriseInvitations])

  const enterpriseInvitation = useMemo(() => {
    return enterpriseInvitations[0]
  }, [enterpriseInvitations])

  const joinEnterprise = async (status) => {
    setSelectedStatus(status)
    setLoading(true);
    enterpriseServices.update_enterprises_invitation(enterpriseInvitation.id, { status }).then(async () => {
      await common.getEnterpriseInvitations();
      await common.fetchUserInfo();
      await common.getTeams();
      setLoading(false);
    }).catch((error) => {
      global.pushError(error);
      setLoading(false);
    })
  }
  
  return (
    <>
      {
        enterpriseInvitation && <Modal
          open={visible}
          onCancel={() => setVisible(false)}
          width={540}
          title={
            <div className="text-center text-xl">
              {t('enterprise.join_organization')}
            </div>
          }
          footer={<div className="flex justify-end">
            <Button
              loading={loading}
              disabled={selectedStatus === 'confirmed'}
              onClick={() => joinEnterprise('reject')}
            >
              {t('button.decline')}
            </Button>
            <Button
              type="primary"
              loading={loading}
              disabled={selectedStatus === 'reject'}
              onClick={() => joinEnterprise('confirmed')}
            >
              {t('button.accept')}
            </Button>
          </div>}
        >
          <div className="my-6">
            <p className="text-center">{t('enterprise.popup.subtitle')}</p>
            <div className="flex items-center mt-4 justify-between py-3 px-4 bg-black-100 rounded-xl">
              <div className="w-[46%]">
                <p className="mb-2">{t('enterprise.organization')}</p>
                <div className="flex items-center">
                  <GroupOutlined className="text-[24px] mr-2"/>
                  <p className="font-semibold text-limited" style={{ width: 'calc(100% - 32px)' }}>{enterpriseInvitation.enterprise.name}</p>
                </div>
              </div>
              <Divider
                className="mx-2"
                type="vertical"
                style={{ height: 52 }}
              />
              <div className="w-[46%] text-start">
                <p className="mb-2">{t('enterprise.popup.inviter')}</p>
                <div className="flex items-center">
                  <UserOutlined className="text-[24px] mr-2"/>
                  <p className="font-semibold text-limited" style={{ width: 'calc(100% - 32px)' }}>{enterpriseInvitation.owner}</p>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <p className="font-semibold">{t('enterprise.popup.accept.title')}</p>
              <ul style={{ marginLeft: -12 }}>
                <li>{t('enterprise.popup.accept.desc_1')}</li>
                <li>{t('enterprise.popup.accept.desc_2')}</li>
                <li>{t('enterprise.popup.accept.desc_3')}</li>
                <li>{t('enterprise.popup.accept.desc_4')}</li>
                <li>{t('enterprise.popup.accept.desc_5')}</li>
              </ul>
            </div>
            <div className="mt-4">
              <p className="font-semibold">{t('enterprise.popup.decline.title')}</p>
              <ul style={{ marginLeft: -12 }}>
                <li>{t('enterprise.popup.decline.desc_1')}</li>
              </ul>
            </div>
          </div>
        </Modal>
      }
    </>
    
  );
}

export default EnterpriseInvitationsModal;